<template>
  <KioskSplashLayout @click.native="handleClick">
    <h1><span>TOUCH SCREEN </span>To Boss Your Burger</h1>
  </KioskSplashLayout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskSplashLayout from '@/layouts/KioskSplashLayout';

@Component({
  components: {
    KioskSplashLayout,
  },
})

/* Index page */
export default class KioskMain extends Vue {
  /**
   * Handle click on screen
   */
  handleClick() {
    this.$router.push({
      name: 'kiosk-options',
    });
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';
h1 {
  color: $white;
  font-size: 43px;
  line-height: 54px;
  font-weight: 300;
  text-align: center;
  text-transform: uppercase;
  padding-bottom: 500px;
  span {
    display: block;
    font-weight: 700;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskMain.vue